import {withStyles} from '@/hocs/withStyles';
import styles from './styles.module.scss';

const List = props => <ul {...props} />;
const ListOl = props => <ol {...props} />;

const ListIcons = withStyles(List, styles, 'list-icons');
const ListCheckmarked = withStyles(List, styles, 'list-checkmarked');
const ListCheckmarkedMargin = withStyles(List, styles, 'list-checkmarked-margin-md');
const ListIconsNoMargin = withStyles(List, styles, 'list-icons-no-margin-t');
const ListIconsNoMarginBottomToMd = withStyles(List, styles, 'list-icons-no-margin-b-to-md');
const ListTerms = withStyles(List, styles, 'list-terms');
const ListNumbered = withStyles(ListOl, styles, 'list-numbered');
const ListNeutral900 = withStyles(List, styles, 'list-neutral900');
/**
 * Redesign 2024
 * */
const ListUnstyled = withStyles(List, styles, 'list-unstyled');
const ListDisc = withStyles(List, styles, 'list-disc');
const ListOlNumbered = withStyles(List, styles, 'list-ol');

export {
  List,
  ListIcons,
  ListCheckmarked,
  ListCheckmarkedMargin,
  ListIconsNoMargin,
  ListIconsNoMarginBottomToMd,
  ListTerms,
  ListNumbered,
  ListNeutral900,
  /**
   * Redesign 2024
   * */
  ListUnstyled,
  ListDisc,
  ListOlNumbered
};
